import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Amplify } from 'aws-amplify';
import { awsExports } from './aws-exports';

Amplify.configure(awsExports as any);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
